module.exports = __webpack_public_path__ + "static/media/map_info.c0c11635.PNG";